












































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxTooltip from '@/dex-shared/components/px-tooltip.vue';
import Icon from '@/dex-shared/components/Icon.vue';

export default Vue.extend({
  components: {
    pxCard,
    pxButton,
    pxTooltip,
    Icon,
  },

  data() {
    return {
      openedSelectorIndex: -1,
    };
  },

  computed: {
    ...mapGetters({
      board: 'currentBoard',
      currentClassrooms: 'currentClassrooms',
    }),
  },

  async created() {
    let boardId = parseInt(this.$route.params.boardId);
    if (!boardId) boardId = 6; //TODO landing page
    this.$store.dispatch('PULL_BOARD', boardId);
    if (!this.currentClassrooms.length) {
      this.$store.dispatch('PULL_CLASSROOMS');
    }
  },

  methods: {
    boardCourses: function(board): Array<Object> {
      const classrooms = board.classrooms || [];
      return classrooms
        .filter(c => c && c.courseByCourseId)
        .reduce((acc, classroom) => {
          const course = classroom.courseByCourseId;
          const accCourse = acc[course.id] || {};
          const accCourseClassrooms = accCourse.classrooms || [];

          return {
            ...acc,
            [course.id]: {
              ...acc[course.id],
              id: course.id,
              name: course.name,
              classrooms: [...accCourseClassrooms, classroom],
            },
          };
        }, {});
    },
    openSelector: function(index: number) {
      if (index == this.openedSelectorIndex) {
        this.openedSelectorIndex = -1;
      } else {
        this.openedSelectorIndex = index;
      }
    },
    addBoardsClassroom: async function(data: any) {
      await this.$store.dispatch('ADD_BOARDS_CLASSROOM', data);
      const boardId = parseInt(this.$route.params.boardId);
      await this.$store.dispatch('PULL_BOARD', boardId);
    },
    removeBoardsClassroom: async function(boardsClassroomId: number) {
      if (confirm('Tem certeza?')) {
        await this.$store.dispatch(
          'REMOVE_BOARDS_CLASSROOM',
          boardsClassroomId,
        );
        const boardId = parseInt(this.$route.params.boardId);
        await this.$store.dispatch('PULL_BOARD', boardId);
      }
    },
  },
});
